import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Register from "./component/auth/Register";
import Login from "./component/auth/Login";
import Home from "./component/pages/Home";
import Header from "./component/pages/Header";
import Footer from "./component/pages/Footer";
import  Productdetails  from "./component/pages/Productdetails";
import Myprofile from "./component/Myprofiecomponent/Myprofile";
import Mycart from "./component/mycartcomponent/Mycart";
import Favourites from "./component/pages/Favourites";
import Contact from "./component/pages/Contact";
import Filter from "./component/pages/Filter";
import OurCollections from "./component/pages/OurCollections";
import Myorder from "./component/Myprofiecomponent/Myorder";
import Address from "./component/Myprofiecomponent/Address";
import Newaddress from "./component/Myprofiecomponent/Newaddress";
import Checkout from "./component/pages/Checkout";
import Aboutus from "./component/aboutUs/Aboutus";
import Productdetail from "./component/ProductDetailscompnt/Productdetail";
import SkeletonEffect from "./component/pages/homeComponents/SkeletonEffect";
import PrivacyPolicy from "./component/pages/PrivacyPolicy";
import TermsOfUse from "./component/pages/TermsOfUse";
import Wallet from "./component/Myprofiecomponent/Wallet";
import Totalearned from "./component/Myprofiecomponent/Totalearned";
import Productvideo from "./component/ProductDetailscompnt/Productvideo";
import ExclusiveFull from "./component/pages/ExclusiveFull";
import Notifications from "./component/pages/Notifications";
import OfferDetail from "./component/pages/OfferDetail";
import ReturnOrder from "./component/Myprofiecomponent/ReturnOrder";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="register" element={<Register />} />
        <Route path="login" element={<Login />} />
        <Route path="header" element={<Header />} />
        <Route path="footer" element={<Footer />} />
        <Route path="example-prd " element={<Productdetails />} />
        <Route path="myprofile" element={<Myprofile />} />
        <Route path="mycart" element={<Mycart />} />
        <Route path="wishlist" element={<Favourites />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="offer-details" element={<OfferDetail />} />
        <Route path="contact" element={<Contact />} />
        <Route path="filter" element={<Filter />} />
        <Route path="our-collections" element={<OurCollections />} />
        <Route path="myorder" element={<Myorder />} />
        <Route path="returnOrder" element={<ReturnOrder />} />
        <Route path="address" element={<Address />} />
        <Route path="new-address" element={<Newaddress />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="about-us" element={<Aboutus />} />
        <Route path="product-details" element={<Productdetail />} />
        <Route path="ske" element={<SkeletonEffect />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-use" element={<TermsOfUse />} />
        <Route path="wallet" element={<Wallet />} />
        <Route path="total-earned" element={<Totalearned />} />
        <Route path="product_video" element={<Productvideo />} />
        <Route path="exclusive-full" element={<ExclusiveFull />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
